import { StyleSheet } from 'aphrodite'

import main from './main'
import image from './image'
import controls from './controls'
import animation from './animation'

export default {
  main: StyleSheet.create(main),
  image: StyleSheet.create(image),
  controls: StyleSheet.create(controls),
  animation: StyleSheet.create(animation)
}



// WEBPACK FOOTER //
// ./src/components/partials/Slideshow/style/index.js